<template>
  <div class="lease-list">
    <van-list v-model="loading" :finished="finished" finished-text="已加载完毕" @load="load">
      <div v-for="card in result.rows" :key="card.id" class="lease-card" @click="selectLeaseCard(card)">
        <div class="card-mask">
          <div class="lease-card-line line1">
            <div class="title">停车月卡 <span v-if="card.spotCount > 1" class="spot-number">{{card.spotCount}}车位</span></div>
            <div class="card-id">{{card.id}}</div>
          </div>
          <div class="lease-card-line line2">
            <div>{{card.parkingLotName}} <span v-if="card.parkingSpotId">{{card.parkingSpotName}}</span></div>
            <div>{{card.leaseProductName}}</div>
          </div>
          <div class="lease-card-line line3">
            {{card.plateNumber}}
          </div>
          <div class="lease-card-line line4">
            <div>{{formatTime(card.startTime, card.endTime)}}</div>
            <div>
              <van-tag v-if="card.status == 0" type="success">待生效</van-tag>
              <van-tag v-else-if="card.status == 1 && card.leftDays < 10" type="warning">{{card.leftDays > 0 ? `仅余${card.leftDays}天` : '今晚到期'}}</van-tag>
              <van-tag v-else-if="card.status == 1" type="primary">余{{card.leftDays}}天</van-tag>
              <van-tag v-else color="gray" text-color="white">已失效</van-tag>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { List, Button, Loading, Tag} from 'vant';
import { router } from '../router';
import dayjs from 'dayjs';

export default {
  components: {
    [List.name] : List,
    [Button.name] : Button,
    [Loading.name] : Loading,
    [Tag.name] : Tag
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      finished : false,
      loading : false,
      result: {
        rows: [],
        total: 0
      }
    };
  },
  filters : {
    upperToMinutes(value) {
      return Math.ceil(value/60) * 60;
    }
  },
  methods: {
    formatTime(start, end) {
      return dayjs(start).format('YYYY年MM月DD日') + ' - ' + dayjs(end).add(-1, 'day').format('YYYY年MM月DD日')
    },
    selectLeaseCard(card) {
      router.push('/lease_card?leaseCardId='+card.id)
    },
    async load(){
      this.loading = true;
      const data = await this.$http.get('/lease/lease_cards', {page: this.page, pageSize: this.pageSize});
      if (this.page == 1) {
        this.result = data;
      } else {
        this.result.rows = this.result.rows.concat(data.rows);
      }
      if (this.page < Math.ceil(data.total / this.pageSize)) {
          this.page ++ ;    
      } else {
        this.finished = true
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="less" scoped>
  .lease-card {
    //background: linear-gradient(to right, #008ee6, #13a6e6);
    background-color: white;
    margin: 15px 10px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    //background: url('../assets/34345132.jpg') no-repeat center center;
    background-size: cover;
    border-radius: 8px;
    overflow: hidden;
  }
  .card-mask{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    //color: white;
    padding: 10px 15px;
    height: 100px;
    //background-color: rgba(0, 0, 0, 0.6);
  }
  .spot-number {
    display: inline-block;
    padding: 0 1px;
    height: 14px;
    line-height: 14px;
    font-weight: normal;
    border: 1px solid #ddd;
    font-size: 12px;
    //color: #ddd;
    margin: 0;
    border-radius: 3px;
  }

  .lease-card-line {
    display: flex;
    justify-content: space-between;
  }

  .title {
    font-size: 22px;
    // text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
  }
  
  .line2, .line3{
    color:gray;
    font-weight: bold;
    font-size: 13px;
    // text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
  }
  .card-id {
    font-family: Consolas, Monaco, Menlo, 'Courier New', Courier, monospace;
  }
  .tips {
    color: gray;
    font-size: 12px;
    margin-top: 10px;
  }
  
</style>